<template>
    <div v-if="dialog">
        <!-- Desktop layout -->
        <v-fade-transition v-if="$vuetify.breakpoint.mdAndUp">
            <CookieCard
                class="my-8 mx-8"
                v-show="dialog"
                :style="{ 'bottom': '100px'}"
                @accept-policies="updateAllUserSettings(true)"
                @reject-policies="updateAllUserSettings(false)"
                @save-custom-settings="saveSettings"
            />
        </v-fade-transition>
        <!-- Desktop layout -->

        <!-- Mobile layout -->
        <CookieDialog
            v-else
            :isDisplayed="dialog"
            @accept-policies="updateAllUserSettings(true)"
            @reject-policies="updateAllUserSettings(false)"
            @save-custom-settings="saveSettings"
        />
        <!-- /Mobile layout -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    import CookieCard from '@/components/gdpr/CookieCard';
    import CookieDialog from '@/components/gdpr/CookieDialog';

    export default {
        name: 'CookieDisclaimer',
        components: {
            CookieCard,
            CookieDialog
        },
        data() {
            return {
                dialog: false
            }
        },
        computed: {
            ...mapGetters([
                'availableTrackings',
                'hasGPDRConsent',
                'isCookieDisclaimerOpened',
                'isIframe',
                'isInternal',
                'isLocalstorageAvailable',
                'isAlternativeMode'
            ]),
            cookieSettingsKey() {
                return `cookie-settings-${this.promoterUuid}`;
            },
            popupDisclaimerKey() {
                return `cookie-disclaimer-${this.promoterUuid}`;
            },
            trackersKey() {
                return `trackers-${this.promoterUuid}`;
            },
            trackersSettings() {
                return this.isLocalstorageAvailable ? (localStorage.getItem(this.trackersKey) ? JSON.parse(localStorage.getItem(this.trackersKey)) : null) : null;
            },
            cookiesSettings() {
                return this.isLocalstorageAvailable ? (localStorage.getItem(this.cookieSettingsKey) ? localStorage.getItem(this.cookieSettingsKey) : null) : null;
            },
            promoterUuid() {
                return this.$route.query.key;
            },
            promoterGPDRConsent() {
                return this.$route.query.rgpd;
            }
        },
        mounted() {
            if (!localStorage.getItem(this.popupDisclaimerKey) && !this.isIframe && !this.isInternal)
                this.toggleCookieDisclaimer();
            else if (!this.hasGPDRConsent  && this.isInternal) {
                this.setCookiesStatus(false);
                this.setTrackingStatus({
                    'provider': 'google',
                    'status': false
                });
                if (this.isLocalstorageAvailable) {
                    localStorage.setItem(this.cookieSettingsKey, false);
                    localStorage.setItem(this.trackersKey, JSON.stringify({ 'google': false }));
                }
            }
            
            if (this.hasGPDRConsent && !this.isIframe) {
                this.setCookiesStatus(this.cookiesSettings ? this.cookiesSettings : false);
                this.setTrackingStatus({
                    'provider': 'google',
                    'status': this.isTrackingEnabledByUser('google')
                });
            }
            
            if (this.isIframe) {
                let trackerStatus = this.promoterGPDRConsent === 'on' || this.promoterGPDRConsent === undefined ? true : false;
                // Enable all trackers and cookies (not stored on browser)
                this.setCookiesStatus(trackerStatus);
                this.setTrackingStatus({
                    'provider': 'google',
                    'status': trackerStatus
                });
            }
        },
        methods: {
            ...mapActions([
                'setCookiesStatus',
                'setTrackingStatus',
                'toggleCookieDisclaimer'
            ]),
            isTrackingEnabledByUser(provider) {
                return this.trackersSettings ? (provider in this.trackersSettings ? this.trackersSettings[provider] : false) : false;
            },
            updateAllUserSettings(status) {
                this.setCookiesStatus(status);
                this.setTrackingStatus({
                    'provider': 'google',
                    'status': status
                });
                if (this.isLocalstorageAvailable) {
                    localStorage.setItem(this.cookieSettingsKey, status);
                    localStorage.setItem(this.trackersKey, JSON.stringify({ 'google': status }));
                }
                this.hidePopup();
            },
            saveSettings() {
                if (this.isLocalstorageAvailable) {
                    localStorage.setItem(this.cookieSettingsKey, true);
                    localStorage.setItem(this.trackersKey, JSON.stringify({ 'google': this.availableTrackings.google }));
                }
                this.hidePopup();
            },
            hidePopup() {
                this.toggleCookieDisclaimer();
                if (this.isLocalstorageAvailable)
                    localStorage.setItem(this.popupDisclaimerKey, true);
            }
        },
        watch: {
            isCookieDisclaimerOpened() {
                this.dialog = this.isCookieDisclaimerOpened;
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_cookie-disclaimer.scss";
</style>


// WEBPACK FOOTER //
// src/components/gdpr/CookieDisclaimer.vue